<script>
/**
 * ****************************************************************************
 * @description     :   Main component for page APP_WorkReport002
 * @created at      :   2024/05/22
 * @created by      :   ANS903 – namnth@ans-asia.com
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import libraries
 */
import { mapMutations, mapState } from 'vuex';
import store from '@/store';
import APP_WorkReport002_store from '@/views/mobile/app_work_report/APP_WorkReport002/store';

/**
 * Import template
 */
import template from './template.html';
import './style.scss';
import messages, { MSG_TITLE, MSG_TYPE } from '@/utils/messages';
/**
 * Define component chat for show page chat
 */
var APP_WorkReport002 = {
    template: template,
    components: {},
    props: {
        typeSelected: {
            type: Number,
            default: 1
        }
    },
    beforeCreate() {
        if (!store.hasModule('APP_WorkReport002')) {
            store.registerModule('APP_WorkReport002', APP_WorkReport002_store);
        }
    },
    created() {
        this.setScreenId(this.screenId);
        this.setHeader(this.header);
    },
    mounted() {
        this.setHeader(this.header);
        this.resetFormData(this.typeSelected);
    },
    unmounted() {
        this.setHeader();
    },
    data() {
        return {
            screenId: 'APP_WorkReport002',
            activeIndex: 0
        };
    },
    emits: ['emitHideDetail'],
    computed: {
        // ...mapState('app', ['user', 'zoom', 'isShowLeftMenu', 'header']),
        ...mapState('APP_WorkReport002', ['optionGroup', 'data']),
        header() {
            const data = {
                title: '業務日報登録',
                topButtons: []
            };
            return data;
        },
        placesLength() {
            return this.data.places.length;
        }
    },
    methods: {
        ...mapMutations('app', [
            'showHeaderError',
            'setScreenId',
            'setHeader',
            'setNotification',
            'showModalMessage',
            'hideModalMessage',
            'hideHeaderError'
        ]),
        ...mapMutations('APP_WorkReport002', ['resetFormData']),
        //     ...mapActions('APP_WorkReport002', ['getScreenData', 'saveRead', 'storeChangeStatus', 'readAllMessage']),
        addNewSchedule() {
            this.data.schedules.push({ no: '', time: '', content: '' });
        },
        changeType() {
            this.resetFormData(this.data.type);
        },
        addNewPlace() {
            if (this.placesLength > 9) {
                return;
            }
            this.data.places.push({
                id: Date.now(),
                order_no1: '',
                order_no2: '',
                onsite_meetings: [],
                daytime: '1',
                onsite_meetings2: [],
                business_partners: [],
                customer_name: '',
                billing_name: '',
                time_start: '',
                time_end: '',
                quantity: '',
                intention_to_arrange: '',
                actions_and_results: '',
                business_details: '',
                impressions: '',
                business_improvement_points: '',
                project_sharing: '1',
                project_sharing_content: '',
                information_sharing: '1',
                information_sharing_content: '',
                other: '',
                action_plan_date: '',
                action_plan_note: '',
                issues: ''
            });
            this.$nextTick(() => {
                this.activeIndex = this.data.places.length - 1;
            });
        },
        hideDetail() {
            this.$emit('emitHideDetail');
        },
        drafSubmit() {},
        submit() {},
        deleteItemTable(index_no, item) {
            if (this.data.schedules.length == 1) return;
            if (!item.time && !item.content) {
                this.data.schedules.splice(index_no, 1);
            } else {
                this.showModalMessage({
                    type: MSG_TYPE.CONFIRM,
                    title: MSG_TITLE.C003,
                    content: messages.C003,
                    cancelText: 'いいえ',
                    okText: 'はい',
                    callback: (ok) => {
                        if (ok) {
                            this.$nextTick(() => {
                                this.data.schedules.splice(index_no, 1);
                            });
                        }
                    }
                });
            }
        },
        removePlace(e, index, id) {
            this.showModalMessage({
                type: MSG_TYPE.CONFIRM,
                title: MSG_TITLE.C003,
                content: messages.C003,
                cancelText: 'いいえ',
                okText: 'はい',
                callback: (ok) => {
                    if (ok) {
                        if (this.activeIndex === index) {
                            this.activeIndex = index > 0 ? index - 1 : 0;
                        } else if (this.activeIndex > index) {
                            this.activeIndex--;
                        }

                        this.data.places = this.data.places.filter((p) => p.id !== id);

                        if (this.activeIndex >= this.data.places.length) {
                            this.activeIndex = this.data.places.length - 1;
                        }
                    }
                }
            });
        }
    }
};
export default APP_WorkReport002;
</script>
